export default "__VITE_ASSET__CZRdFQHi__"